import React, { FunctionComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-solid-svg-icons';
import Button from 'components/UI/V3/Button/Button';
import { useHistory } from 'react-router-dom';
import PrivatePage from './PrivatePage';
import styles from './NotAllowed.module.scss';

const NotAllowed: FunctionComponent = () => {
    const history = useHistory();

    return (
        <PrivatePage
            title="Not Allowd - Cuddles"
            pageName="/not-allowed"
        >
            <div className={styles.container}>
                <div className={styles.content}>
                    <div className={styles.iconWrapper}>
                        <FontAwesomeIcon
                            icon={faLock}
                            className={styles.icon}
                        />
                    </div>

                    <div className={styles.title}>Access Denied</div>

                    <p className={styles.description}>
                        <span>You don&apos;t have permission to access this content.</span>
                        <span>If you think this is a mistake, contact your administrator.</span>
                    </p>

                    <Button
                        variant="primary"
                        className={styles.backButton}
                        label="Go Back"
                        onClick={() => history.goBack()}
                    />
                </div>
            </div>
        </PrivatePage>
    );
};

export default NotAllowed;
